/**
 * Может ли пользователь завершать задачу (начисление баллов / закрытие CardPointData).
 */
export default function canCompleteCardTask(currentUser, superuserIds = []) {
  if (!currentUser?.id) {
    return false;
  }

  if (currentUser.isAdmin === true || currentUser.isSAdmin === true) {
    return true;
  }

  const ids = Array.isArray(superuserIds) ? superuserIds : [];
  return ids.map(String).includes(String(currentUser.id));
}
